import PropTypes from 'prop-types';
import React from 'react';

const MagnifyIcon = ({ size, color, title, style }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
  >
    <title>{title}</title>
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
    <path d="M21 21l-6 -6" />
  </svg>
);

MagnifyIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  title: PropTypes.string,
  style: PropTypes.objectOf(PropTypes.any),
};

MagnifyIcon.defaultProps = {
  size: 16,
  color: '#FFF',
  title: 'Rechercher',
  style: {},
};

export default MagnifyIcon;
